import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/danger.svg";
var DangerSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DangerSolid_default as default
};
